export const containerVanConstants = {
    CONTAINER_VAN_FETCHING: 'CONTAINER_VAN_FETCHING',
    CONTAINER_VAN_FETCHED: 'CONTAINER_VAN_FETCHED',
    CONTAINER_VAN_SUBMITTING: 'CONTAINER_VAN_SUBMITTING',
    CONTAINER_VAN_SUBMITTED: 'CONTAINER_VAN_SUBMITTED',
    GET_CONTAINERS: 'GET_CONTAINERS',
    GET_CONTAINER: 'GET_CONTAINER',
    SEARCH_CONTAINER_VAN: 'SEARCH_CONTAINER_VAN',
    CONTAINER_VAN_CLEAR: 'CONTAINER_VAN_CLEAR',
    ALL_BOOKING_CONTAINER: 'ALL_BOOKING_CONTAINER',
}